import React from 'react';
import { t, Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import FontIcon from '@src/components/FontIcon';
import ScoreInput from '@src/components/ScoreInput';
import Separator from '@src/components/Separator';
import TextInput from '@src/components/TextInput';
import { H1 } from '@src/components/Typography';
import { i18n } from '@src/i18n';

import { ModalContainer, Row } from './styled';

type Props = {
  onSubmit: () => void;
  loading?: boolean;
};

const Title = styled(H1)`
  width: 100%;
  text-align: center;
`;

const Star = styled(FontIcon).attrs({
  name: 'star-o',
  size: 25,
})``;

const Comment = styled(TextInput).attrs({
  multiline: true,
  numberOfLines: 4,
  mode: 'outlined',
})``;

const SubmitButton = styled(Button).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'contained',
  labelStyle: {
    color: theme.colors.onPrimary,
  },
}))`
  width: 100%;
`;

const Component: React.FC<Props> = (props) => {
  const { loading, onSubmit } = props;

  const submitReviewHandler = React.useCallback(() => {
    onSubmit?.();
  }, [onSubmit]);

  return (
    <ModalContainer>
      <Title>
        <Trans>Submit your review</Trans>
      </Title>
      <Separator level={2} />
      <Row>
        <ScoreInput name="rate" label={i18n._(t`Rate`)} score={0}>
          <Star />
        </ScoreInput>
      </Row>
      <Separator />
      <Row>
        <Comment
          name="comment"
          label={i18n._(t`Comment`)}
          disabled={loading}
          keyboardType="ascii-capable"
          autoCompleteType="off"
          returnKeyType="send"
          onSubmitEditing={submitReviewHandler}
        />
      </Row>
      <Separator />
      <Row>
        <SubmitButton onPress={submitReviewHandler}>
          <Trans>Submit</Trans>
        </SubmitButton>
      </Row>
    </ModalContainer>
  );
};

export default React.memo(Component);
